import classnames from 'classnames';

type DashboardTypes = {
    className?: string;
    icon: React.ReactNode;
    title: React.ReactNode;
    description: React.ReactNode;
    cta?: React.ReactNode;
    'data-testid'?: string;
    fullWidthDescription?: boolean;
};

const DashboardCTA = (props: DashboardTypes) => {
    const { className, icon, title, description, cta } = props;

    return (
        <div
            className={classnames(
                className,
                'grid min-h-[96px] grid-cols-[1fr_10fr] items-center justify-center gap-m rounded-s border border-secondary-90 p-l'
            )}
            data-testid={props['data-testid']}
        >
            <div className="m-auto flex h-3xl w-3xl items-center justify-center rounded-m bg-secondary-95 align-middle">
                {icon}
            </div>
            <div className="grid max-w-5xl grid-cols-[60%_auto] max-m:grid-cols-[auto] min-xl:gap-l">
                <div className="col-span-1">
                    <div className="text-m font-bold">{title}</div>
                    <div className="`mb-s text-s font-reg">{description}</div>
                </div>
                <div className="col-span-1 place-content-center text-right text-s">
                    {cta}
                </div>
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DashboardCTA;
